export const formatTableList = (item) => {
  item.cost !== undefined && (item.cost = item.cost.toFixed(2));
  item.avg_click_cost !== undefined && (item.avg_click_cost = item.avg_click_cost.toFixed(2));
  item.avg_show_cost !== undefined && (item.avg_show_cost = item.avg_show_cost.toFixed(2));
  item.convert_cost !== undefined && (item.convert_cost = item.convert_cost.toFixed(2));
  item.deep_convert_cost !== undefined && (item.deep_convert_cost = item.deep_convert_cost.toFixed(2));
  item.attribution_convert_cost !== undefined && (item.attribution_convert_cost = item.attribution_convert_cost.toFixed(2));
  item.attribution_deep_convert_cost !== undefined && (item.attribution_deep_convert_cost = item.attribution_deep_convert_cost.toFixed(2));
  item.download_start_cost !== undefined && (item.download_start_cost = item.download_start_cost.toFixed(2));
  item.download_finish_cost !== undefined && (item.download_finish_cost = item.download_finish_cost.toFixed(2));
  item.install_finish_cost !== undefined && (item.install_finish_cost = item.install_finish_cost.toFixed(2));
  item.active_register_cost !== undefined && (item.active_register_cost = item.active_register_cost.toFixed(2));
  item.active_cost !== undefined && (item.active_cost = item.active_cost.toFixed(2));
  item.attribution_next_day_open_cost !== undefined && (item.attribution_next_day_open_cost = item.attribution_next_day_open_cost.toFixed(2));
  item.active_pay_cost !== undefined && (item.active_pay_cost = item.active_pay_cost.toFixed(2));

  item.ctr !== undefined && (item.ctr = (item.ctr * 100).toFixed(2) + "%");
  item.convert_rate !== undefined &&
    (item.convert_rate = (item.convert_rate * 100).toFixed(2) + "%");
  item.deep_convert_rate !== undefined &&
    (item.deep_convert_rate = (item.deep_convert_rate * 100).toFixed(2) + "%");
  item.download_start_rate !== undefined &&
    (item.download_start_rate = (item.download_start_rate * 100).toFixed(2) + "%");
  item.download_finish_rate !== undefined &&
    (item.download_finish_rate = (item.download_finish_rate * 100).toFixed(2) + "%");
  item.install_finish_rate !== undefined &&
    (item.install_finish_rate = (item.install_finish_rate * 100).toFixed(2) + "%");
  item.active_register_rate !== undefined &&
    (item.active_register_rate = (item.active_register_rate * 100).toFixed(2) + "%");
  item.active_rate !== undefined && (item.active_rate = (item.active_rate * 100).toFixed(2) + "%");
  item.attribution_next_day_open_rate !== undefined &&
    (item.attribution_next_day_open_rate =
      (item.attribution_next_day_open_rate * 100).toFixed(2) + "%");
  item.active_pay_rate !== undefined &&
    (item.active_pay_rate = (item.active_pay_rate * 100).toFixed(2) + "%");
  item.valid_play_rate !== undefined &&
    (item.valid_play_rate = (item.valid_play_rate * 100).toFixed(2) + "%");
  item.play_over_rate !== undefined &&
    (item.play_over_rate = (item.play_over_rate * 100).toFixed(2) + "%");
}